import React from "react";
import CPFNotFound from "../CPFNotFound";
import CPFFound from '../CPFFound';

const MsgFirstAccess = ({ cpf, userEmail, cpfEncontrado }) => {
  return (
    <>
      {cpfEncontrado ? (
        <CPFFound cpf={cpf} userEmail={userEmail} />
      ) : (
        <CPFNotFound />
      )}
    </>
  );
};

export default MsgFirstAccess;
